import { render, staticRenderFns } from "./PillarsModal.vue?vue&type=template&id=d48ce81e&"
import script from "./PillarsModal.vue?vue&type=script&lang=js&"
export * from "./PillarsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports